/**
 * Open/close state for the ⌘K palette.
 *
 * Deliberately NOT persisted: a command palette that is open when you return to the tab
 * is a modal blocking the page for no reason you initiated. Its sibling, the Ask panel
 * (ask/useAskStore), does persist — because a panel you docked is a preference, whereas a
 * palette you opened is an action.
 *
 * A store rather than React context because the palette has three unrelated entry points
 * (the sidebar trigger, the Help popover's "Search help" row, and the global ⌘K binding)
 * and none of them are near it in the tree.
 */
import { create } from 'zustand'

interface SearchState {
  open: boolean
  query: string
  openSearch: (initialQuery?: string) => void
  closeSearch: () => void
  setQuery: (query: string) => void
}

export const useSearchStore = create<SearchState>(set => ({
  open: false,
  query: '',
  // Opening always resets the query unless one is supplied. Restoring the last search
  // reads as a stuck field far more often than it saves typing — the query that mattered
  // has usually already been navigated to.
  openSearch: initialQuery => set({ open: true, query: initialQuery ?? '' }),
  closeSearch: () => set({ open: false }),
  setQuery: query => set({ query }),
}))
